































import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseLoaderCircular from '../base-loader-circular/_base-loader-circular.vue';
import BaseIcon from '../base-icon/_base-icon.vue';
import { BaseButtonIcon } from '../base-button-icon';
import { IconSize } from '../base-icon';
import { ModalSize } from './types/enums/modal-size';
import BaseModalSubContainer from './_base-modal-sub-container.vue';

@Component({
  name: 'BaseModal',
  components: {
    BaseIcon,
    BaseLoaderCircular,
    BaseButtonIcon,
    BaseModalSubContainer,
  },
  data: () => ({
    IconSize,
  }),
})
export default class BaseModal extends Vue {
  @Prop({ default: ModalSize.Small }) size: ModalSize;
  @Prop({ default: true }) closable: boolean;
  @Prop() loading: boolean;
  @Prop({ default: true }) padded: boolean;
  @Prop({ default: true }) showBackdrop: boolean;
  @Prop({ default: false }) blurBackground: boolean;

  handleClose() {
    if (this.closable) {
      this.$emit('close');
    }
  }

  handleKeyup(e: KeyboardEvent) {
    if (e.key === 'Escape') {
      this.handleClose();
    } else if (e.key === 'Enter') {
      this.$emit('enter');
    }
  }

  mounted() {
    if (this.closable) {
      window.addEventListener('keyup', this.handleKeyup);
    }
  }
}
